// Module
var code = `<div class="content-margin flex-vertical">
    <div>
        <ul class="nav nav-tabs" data-bind="foreach: router.navigationModel">
            <li data-bind="css: { active: isActive }, visible: nav">
                <a data-bind="attr: { href: hash }, text: tabName"></a>
            </li>
        </ul>
    </div>

    <div class="panel" data-bind="css: { 'flex-grow': growContainer }">
        <div data-bind="router: { cacheViews: false }">
        </div>
    </div>
    
</div>

`;
// Exports
export default code;